const initState = {
    clients: [],
    isLoading: false,
    isSaving: false,
    savingError: null,
    error: null
}


export const SET_CLIENTS = "SET_CLIENTS"
export const SET_CLIENTS_LOADING = "SET_CLIENTS_LOADING"
export const SET_CLIENTS_SAVING = "SET_CLIENTS_SAVING"
export const SET_CLIENTS_SAVING_ERROR = "SET_CLIENTS_SAVING_ERROR"
export const ADDED_NEW_CLIENT = "ADDED_NEW_CLIENT"
export const SET_CLIENTS_ERROR = "SET_CLIENTS_ERROR"
// export const UPDATE_CLIENT = "UPDATE_CLIENT"

const clientsReducer = (state = initState, action) => {
    switch (action.type) {
        case SET_CLIENTS_ERROR:
            return {
                ...state,
                error: state.error
            }
        case ADDED_NEW_CLIENT:
            return {
                ...state,
                clients: state.clients.concat(action.newClient)
            }
        case SET_CLIENTS:
            return {
                ...state,
                clients: action.clients
            }
        case SET_CLIENTS_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            }
        case SET_CLIENTS_SAVING:
            return {
                ...state,
                isSaving: action.isSaving
            }
        case SET_CLIENTS_SAVING_ERROR:
            return {
                ...state,
                savingError: action.savingError
            }
        default:
            break;
    }

    return state
}

export default clientsReducer;